/**
 * `data-table` schema (TDD §5.1). The non-spatial proof kind: loot tables / item-location
 * libraries / grab-bag sources. No geometry, no 3Cs. Rows carry arbitrary typed fields.
 */
import { z } from 'zod';

const RowSchema = z
  .object({
    id: z.string().min(1),
    weight: z.number().finite().optional(),
    refs: z.array(z.string()).optional(),
  })
  .passthrough(); // arbitrary extra typed fields are allowed

export const DataTableLevelSchema = z.object({
  // Optional (default handled in the validator) — a Zod `.default()` here would make the
  // schema's input/output types diverge and break `ZodType<DataTableLevel>` assignability.
  weightMode: z.enum(['probability', 'relative']).optional(),
  rows: z.array(RowSchema).min(1),
});

export type DataTableLevel = z.infer<typeof DataTableLevelSchema>;
export type DataTableRow = z.infer<typeof RowSchema>;
